import { useState } from "react";
import { faqs } from "@/mocks/comicData";

function Faq() {
  const [open, setOpen] = useState<number>(0);

  return (
    <section id="faq" className="container-page py-16 md:py-20">
      <div className="grid grid-cols-1 gap-10 lg:grid-cols-5">
        <div className="lg:col-span-2">
          <span className="eyebrow">
            <i className="ri-question-line"></i>
            常见问题
          </span>
          <h2 className="section-title mt-3">关于轻松看的那些小事</h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600">
            关于大黄丫头漫画的更新、阅读和下载等常见疑问，我们都帮你整理好啦。如果还有别的困惑，欢迎联系我们。
          </p>
          <div className="mt-6 flex items-center gap-3 rounded-2xl bg-primary-100 p-4">
            <span className="flex h-10 w-10 items-center justify-center rounded-full bg-primary-500 text-xl text-background-50">
              <i className="ri-mail-send-line"></i>
            </span>
            <div>
              <div className="text-sm font-bold text-foreground-950">没找到答案？</div>
              <div className="text-xs text-foreground-600">发邮件告诉我们吧</div>
            </div>
          </div>
        </div>

        <div className="lg:col-span-3">
          <div className="flex flex-col gap-3">
            {faqs.map((item, i) => {
              const isOpen = open === i;
              return (
                <div
                  key={item.q}
                  className={`overflow-hidden rounded-2xl border transition-colors ${
                    isOpen ? "border-primary-300 bg-background-50" : "border-background-200 bg-background-100"
                  }`}
                >
                  <button
                    type="button"
                    onClick={() => setOpen(isOpen ? -1 : i)}
                    className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                    aria-expanded={isOpen}
                  >
                    <h3 className="font-heading text-base text-foreground-950 md:text-lg">
                      {item.q}
                    </h3>
                    <span
                      className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-lg transition-transform duration-300 ${
                        isOpen ? "rotate-45 bg-primary-500 text-background-50" : "bg-background-50 text-primary-600"
                      }`}
                    >
                      <i className="ri-add-line"></i>
                    </span>
                  </button>
                  {isOpen && (
                    <div className="px-5 pb-5 text-sm leading-relaxed text-foreground-600">
                      {item.a}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}

export default Faq;